export const CONNECTION_STATUS_CHANGE = 'CONNECTION_STATUS_CHANGE';
export const ASYNC_REQUEST = 'ASYNC_REQUEST';
export const DEVICE_DATA_CHANGE = 'DEVICE_DATA_CHANGE';
export const DEVICE_EVENT = 'DEVICE_EVENT';
export const INFERENCE_COMPLETED = 'INFERENCE_COMPLETED';
